import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Avatar, Box, Divider, Skeleton, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { BOX_SHADOW_VALUE } from "../../utils/constants";

const WidgetCard = (props) => {
  const { profilePicUrl, handleName, ELEM, caption } = props;
  const [showMore, setShowMore] = useState(false);
  return (
    <>
      <Box boxShadow={BOX_SHADOW_VALUE} marginX={"auto"} sx={{ width: { sm: "300px" } }}>
        <Box p={1}>
          <Box>
            <Stack direction={"row"}>
              <Avatar src={profilePicUrl} sx={{ mr: 1, width: 18, height: 18 }} />
              <Typography
                className="text-truncate"
                sx={{
                  maxWidth: {
                    lg: "150px",
                    sm: "80px",
                    xs: "230px",
                    md: "200px",
                  },
                }}
              >
                {handleName}
              </Typography>
            </Stack>
          </Box>
          <Box position={"relative"}>
            {props.showBanner && (
              <Box
                borderRadius={"10px"}
                position="absolute"
                top={"50%"}
                zIndex={10}
                padding={1}
                bgcolor={"#fff"}
                textAlign="center"
                fontSize="0.875rem"
              >
                <Typography>Enter your description in the textbox to generate post</Typography>
              </Box>
            )}
            <Box
              sx={{
                minHeight: { xs: "200px", lg: "300px" },
                filter: props.disabled ? "blur(2px)" : "",
                pointerEvents: props.disabled ? "none" : "auto",
              }}
            >
              {ELEM}
            </Box>
          </Box>
          <Divider light sx={{ mb: 1 }} />
          <Box paddingX={1}>
            <Box display={"flex"} paddingY={2} justifyContent={"space-between"}>
              <Box gridColumn={"auto"} display={"flex"} alignItems={"center"}>
                {/* TODO replace these images Address for PROD from InstaCard */}
                <img src="ig_like.png" className="icon-6 mr-2 " />
                <img src="ig_comment.png" className="icon-6 mr-2 " />
                <img src="ig_share.png" className="icon-6 mr-2 " />
              </Box>
              <Box>
                <img src="/save.svg" alt="" style={{ width: "16px !important" }} />
              </Box>
            </Box>
            <Box>
              <Typography component={"h6"} fontSize={".875rem"} fontWeight={600}>
                1,234 likes
              </Typography>
            </Box>
          </Box>
          <Box sx={{ px: 1 }}>
            {caption?.length > 0 ? (
              <Typography
                sx={{
                  transition: "max-height 0.3s ease-in-out",
                  overflow: "auto",
                  whiteSpace: "pre-line",
                  maxHeight: showMore ? "500px" : "72px",
                  filter: props.disabled ? "blur(2px)" : "",
                  pointerEvents: props.disabled ? "none" : "auto",
                }}
              >
                {caption}
              </Typography>
            ) : (
              <Box marginTop={2}>
                <Skeleton count={3} style={{ marginTop: "8px" }} />
              </Box>
            )}
            <Box
              marginLeft={"auto"}
              textAlign="right"
              sx={{
                cursor: "pointer",
                filter: props.disabled ? "blur(2px)" : "",
                pointerEvents: props.disabled ? "none" : "auto",
              }}
              onClick={() => {
                setShowMore(!showMore);
              }}
            >
              <Typography>
                Show{" "}
                {!showMore ? (
                  <>
                    More
                    <KeyboardArrowDownIcon />
                  </>
                ) : (
                  <>
                    Less
                    <KeyboardArrowUpIcon />
                  </>
                )}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default WidgetCard;
